import React from 'react';
import { Link } from 'react-router-dom';

export const ExternalLink = ({ offer }) => {
  return (
    <Link
      style={{ textDecoration: 'none', width: 'inherit' }}
      className='button small w-button'
      to={{
        pathname: offer.externalUrl,
      }}
      target='_blank'
    >
      {offer.listingType === 'ASSET_SALES' ? 'Make Offer' : 'Start Investment'}
    </Link>
  );
};



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ReadyToInvestButton/ExternalLink.js